import './accessibility-hidden-focus-group.css'
import { AccessibilityHiddenFocusGroupElement } from './AccessibilityHiddenFocusGroupElement'

customElements.define('accessibility-hidden-focus-group', AccessibilityHiddenFocusGroupElement)
